import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import { VERIFICATION_TOKEN } from "../constants/global.constants";
import {
  countryAction,
  homeActions,
  authActions,
  propertyActions,
} from "../redux/actions";
import PublicRoute from "./Route/PublicRoute";
import PrivateRoute from "./Route/PrivateRoute";
import { getDecryptPayload } from "../system";
import { USER_ROLE } from "../system/global-enums";
import SignalRWrapper from "../shared/components/signalr-wrapper/SignalRWrapper";
import { handleNavigation } from "./utility";

const App = (props) => {
  const {
    user,
    userRole,
    isAuthenticated,
    getAllCurrencies,
    getAllCountries,
    isNavigateToDefault,
    setIsNavigateToDefault,
    updateUserRole,
    getAllHobbies,
    getAllPropertyTypes,
    getAllDayToDayActivity,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { token } = getDecryptPayload();
  const verificationToken = searchParams.get(VERIFICATION_TOKEN);

  useEffect(() => {
    if (isAuthenticated) {
      getAllCountries();
      getAllCurrencies();

      if (userRole === USER_ROLE.ADMIN || userRole === USER_ROLE.SUPER_ADMIN) {
        getAllHobbies();
        getAllPropertyTypes();
        getAllDayToDayActivity();
      }
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);

  useEffect(() => {
    handleNavigation(
      isAuthenticated,
      user,
      userRole,
      navigate,
      location.pathname,
      verificationToken,
      isNavigateToDefault
    );
    if (isNavigateToDefault) {
      setIsNavigateToDefault(false);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, isNavigateToDefault]);

  return (
      <SignalRWrapper token={token}>
        <PublicRoute isAuthenticated={isAuthenticated} />
        {isAuthenticated && (
          <PrivateRoute
            user={user}
            userRole={userRole}
            hasMultipleRoles={user.hasMultipleRoles}
            updateUserRole={updateUserRole}
          />
        )}
        <ToastContainer />
      </SignalRWrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  userRole: state.authReducer.userRole,
  isAuthenticated: state.authReducer.isAuthenticated,
  isNavigateToDefault: state.authReducer.isNavigateToDefault,
});

const mapDispatchToProps = (dispatch) => ({
  setIsNavigateToDefault: (flag) =>
    dispatch(authActions.setIsNavigateToDefault(flag)),
  updateUserRole: (id) => dispatch(authActions.updateUserRole(id)),
  getAllCurrencies: () => dispatch(homeActions.getAllCurrencies()),
  getAllCountries: () => dispatch(countryAction.getAllCountries()),
  getAllHobbies: () => dispatch(homeActions.getAllHobbies()),
  getAllPropertyTypes: () => dispatch(propertyActions.getAllPropertyTypes()),
  getAllDayToDayActivity: () => dispatch(homeActions.getAllDayToDayActivity()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
